var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#EDF5FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1971_30643",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H6V24H24V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1971_30643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 20.0625C8.3175 20.0625 8.0625 19.8075 8.0625 19.5V11.25C8.0625 7.9425 9.0675 6.9375 12.375 6.9375H17.625C20.9325 6.9375 21.9375 7.9425 21.9375 11.25V18.75C21.9375 18.87 21.9375 18.9825 21.93 19.1025C21.9075 19.41 21.63 19.65 21.33 19.6275C21.0225 19.605 20.7825 19.335 20.805 19.0275C20.8125 18.9375 20.8125 18.84 20.8125 18.75V11.25C20.8125 8.5725 20.31 8.0625 17.625 8.0625H12.375C9.69 8.0625 9.1875 8.5725 9.1875 11.25V19.5C9.1875 19.8075 8.9325 20.0625 8.625 20.0625Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.0625H11.25C9.495 23.0625 8.0625 21.63 8.0625 19.875V19.3875C8.0625 17.895 9.2775 16.6875 10.7625 16.6875H21.375C21.6825 16.6875 21.9375 16.9425 21.9375 17.25V19.875C21.9375 21.63 20.505 23.0625 18.75 23.0625ZM10.7625 17.8125C9.8925 17.8125 9.1875 18.5175 9.1875 19.3875V19.875C9.1875 21.015 10.11 21.9375 11.25 21.9375H18.75C19.89 21.9375 20.8125 21.015 20.8125 19.875V17.8125H10.7625Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.8125H12C11.6925 11.8125 11.4375 11.5575 11.4375 11.25C11.4375 10.9425 11.6925 10.6875 12 10.6875H18C18.3075 10.6875 18.5625 10.9425 18.5625 11.25C18.5625 11.5575 18.3075 11.8125 18 11.8125Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.4375H12C11.6925 14.4375 11.4375 14.1825 11.4375 13.875C11.4375 13.5675 11.6925 13.3125 12 13.3125H15.75C16.0575 13.3125 16.3125 13.5675 16.3125 13.875C16.3125 14.1825 16.0575 14.4375 15.75 14.4375Z",
    fill: "#002857"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBlueIcon);
export default __webpack_public_path__ + "static/media/book_blue_icon.942de8f9e53ffd33ac2abc8e1a8e359d.svg";
export { ForwardRef as ReactComponent };